import { Grid } from "@mui/material"
import { useContext, useState } from "react"
import { ProfileContext, ProfileContextPayload } from "../../../../Context/ProfileDetailsContext"
import { useNavigate, useSearchParams } from "react-router-dom"
import SAndPComparisonTab from "../../IULProfileTabs/SAndPComparisonTab/SAndPComparisonTab"
import AnnuityAccValueTab from "../../AnnuityProfileTabs/AnnuityAccValueTab"
import AnnuityFeesTab from "../../AnnuityProfileTabs/AnnuityFeesTab"
import GlobalTabsComponent from "../../../../GlobalComponent/GlobalTabsComponent/GlobalTabsComponent"

const AnnuityAccumulationOutput = () => {
    const {
        accumulationPlanData,
    } = useContext(ProfileContext) as ProfileContextPayload

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const userId = searchParams.get("user_id");
    const tabValue = searchParams.get('tab')

    const [tabNavigationvalue, setTabNavigationValue] = useState(tabValue);

    const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
        setTabNavigationValue(newValue);

        switch (newValue) {
            case '1':
                navigate(`/profile/annuityProfileDetails/annuityAccumulation?user_id=${userId}&tab=1`);
                break;
            case '2':
                navigate(`/profile/annuityProfileDetails/annuityAccumulation?user_id=${userId}&tab=2`);
                break;
            case '3':
                navigate(`/profile/annuityProfileDetails/annuityAccumulation?user_id=${userId}&tab=3`);
                break;
        }
    };

    return (
        <>
            <Grid container>
                <Grid item xs={12}
                    sx={{
                        backgroundColor: "#fff",
                        padding: "0px 20px",
                        borderBottom: "1px solid #E2E8F0"
                    }}
                >
                    <GlobalTabsComponent
                        value={tabNavigationvalue || '1'}
                        onChange={handleTabChange}
                        normalColor="#45556C"
                        selectedColor="#04385D"
                        indicatorColor="#04385D"
                        tabs={[
                            { label: "S&P Comparison", value: "1" },
                            { label: "Account Value", value: "2" },
                            { label: "Fees", value: "3" },
                        ]}
                    />
                </Grid>
                <Grid item xs={12} padding={"20px"}>
                    {
                        tabValue == '1' && <SAndPComparisonTab />
                    }
                    {
                        tabValue == '2' && <AnnuityAccValueTab accumulationPlanData={accumulationPlanData} />
                    }
                    {
                        tabValue == '3' && <AnnuityFeesTab />
                    }
                </Grid>
            </Grid>
        </>
    )
}

export default AnnuityAccumulationOutput
